<template>
    <div class="specialDetaidBox">
        <MaskLoading v-if="isShow"></MaskLoading>
        <!-- <banner :bannerList="bannerList"></banner> -->
        <img src="../../assets/special/db1.jpg" alt="" class="mobileImg" v-if="isMobile">
        <img src="../../assets/special/db1_pc.jpg" alt="" class="mobileImg" v-else>
        <div class="special_warpper">
            <!--  -->
            <div class="p20">
                <backSpecial></backSpecial>
                <div>
                    <div class="arrow_box mb20">
                        <div class="arrow_title">二次报销的理赔流程</div>
                        <div>
                            <img src="../../assets/special/d1t.jpg" alt="" style="width:100%;display: block;"
                                v-if="isMobile">
                            <img src="../../assets/special/d1t_pc.jpg" alt="" style="width:100%;display: block;" v-else>
                        </div>
                    </div>
                </div>
                <!--  -->
                <div>
                    <div class="title mb20">保障內容</div>
                    <div class="table_box mb20">
                        <div class="tab_title_box">
                            <div class="tab_title">参保性质</div>
                            <div class="tab_title">报销形式</div>
                            <div class="tab_title">计算方式</div>
                            <div class="tab_title">理赔范围</div>
                        </div>
                        <div class="table_info_box">
                            <div class="tab_cell">普惠性(工会会员均可享受)</div>
                            <div class="tab_cell">系统核算<br>自动入卡</div>
                            <div class="tab_cell tab_link" @click="drawer = true">住院医疗<br>门诊医疗</div>
                            <div class="tab_cell">最高互助金额<br>200653元</div>
                        </div>
                    </div>
                </div>
                <!--  -->
                <div>
                    <div class="title mb20">温馨提示</div>
                    <div class="desc mb20">
                        1、“个人自费”、“自付二”不享受互助金。<br>
                        2、员工需持有工会会员互助服务卡。<br>
                        3、拖欠医疗保险费,保障期限内未补交不享受互助金。<br>
                        4、需是北京市总工会管理的工会会员。<br>
                        5、工伤、生育、职业病导致的医疗费用不享受互助金。<br>
                        6、被保障人不可采取欺诈手段骗取互助金。
                    </div>
                </div>
                <!--  -->
                <div>
                    <div class="title mb20">咨询电话</div>
                    <footerTel tel="010-83570059"></footerTel>
                </div>

                <div class="footer ">本页面仅供参考,具体以北京市职工互助保障服务中心公示细则为准</div>
            </div>
            <!-- 弹层 -->
            <el-drawer title="互助金计算规则" size="60%" custom-class="custom-class" :visible.sync="drawer"
                :direction="direction">
                <div class="drawer_box">
                    <img src="../../assets/special/liTable.jpg" alt="" class="drawer_img">
                </div>
            </el-drawer>

        </div>
    </div>

</template>

<script>
// import banner from "../../components/banner.vue"
import MaskLoading from "@/components/maskLoading.vue";
import Mixins from "../../script/getMobile";
import backSpecial from "@/components/backSpecial.vue"
import footerTel from "@/components/specialFooterTel.vue"
export default {
    mixins: [Mixins],
    name: "",
    data() {
        return {
            isShow: true,
            drawer: false,
            direction: 'btt',
            bannerList: [
                { "src": require("@/assets/special/baoxiao.jpg") },
                // { "src": require("@/assets/special/baoxiao.jpg") }
            ],
        }
    },
    components: {
        // banner,
        MaskLoading,
        backSpecial,
        footerTel
    },
    mounted() {
        setTimeout(() => {
            this.isShow = false;
        }, 200)
    },
    activated() {
        window.scrollTo(0, 0);
    },
    deactivated() {
        this.drawer = false;
    }
}
</script>

<style lang="less" scoped>
@import url(../../styles/specialDetail.less);

.specialDetaidBox {
    .table_box {

        border: 1px solid #eaeff3;
        overflow: hidden;

        .tab_title_box {
            display: flex;
            flex-wrap: wrap;

            .tab_title {
                flex: 1;
                text-align: center;
                background-color: #F2F9FE;
                font-size: 14px;
                font-weight: bold;
                border-left: 1px solid #ededed;
                border-bottom: 1px solid #ededed;
                margin-left: -1px;
                padding: 10px 0;
            }
        }


        .table_info_box {
            display: flex;
            flex-wrap: wrap;

            .tab_cell {
                flex: 1;
                font-size: 14px;
                text-align: center;
                padding: 10px 0;
                border-left: 1px solid #ededed;
                border-bottom: 1px solid #ededed;
                margin-left: -1px;
                margin-bottom: -1px;

            }


        }


    }
}
</style>